import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import YTDSummary from './../components/YTDSummary';
import {
  getYtdSummaryData
} from '../actions/reportsActions';

const mapDispatchToProps = dispatch => {
  return {
  	getYtdSummaryData: () => {
  		dispatch(getYtdSummaryData());
  	}
  };
};

const mapStateToProps = state => ({
	reportSeasons: state.reports.seasons,
	reportSeasonsList: state.reports.seasonsList,
	fetchingYtdSummaryDataStatus: state.reports.fetchingYtdSummaryDataStatus,
	seasons: state.seasons.seasons,
	seasonsList: state.seasons.seasonsList,
	fetchingSeasonsStatus: state.seasons.fetchingSeasonsStatus
});

const YTDSummaryContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(YTDSummary));
export default YTDSummaryContainer;



// WEBPACK FOOTER //
// ./src/containers/YTDSummaryContainer.js